import { useLayoutEffect } from 'react';

import { useAppDispatch } from '@shared/store';
import { actions } from '@shared/store/ducks';
import { formatCompanyDisplayName } from '@shared/utils/companyDisplayName';
import { useCompanyControllerGetCompanyQuery } from '@shared/services/apiService';

export const useAuthenticatedUserCompanySync = (companyId?: string) => {
  const dispatch = useAppDispatch();

  const {
    data: companyData,
    isLoading,
    isSuccess,
  } = useCompanyControllerGetCompanyQuery({ id: companyId! }, { skip: !companyId });

  useLayoutEffect(() => {
    if (!companyId || isLoading || !isSuccess || !companyData) {
      return;
    }

    const title = formatCompanyDisplayName(companyData.name);
    if (!title) {
      return;
    }

    dispatch(
      actions.auth.setAuthenticatedUserCompany({
        logo: companyData.logo ?? '',
        title,
      }),
    );
  }, [companyData, companyId, dispatch, isLoading, isSuccess]);

  return {
    isCompanyLoading: Boolean(companyId) && isLoading,
    companyData,
  };
};
